/**
 * @generated SignedSource<<0380776db1ce1581923277f5bff049c2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIStudioTaskState = "COMPLETED" | "ERROR" | "NO_CREDITS" | "PROCESSING" | "WAITING";
export type sideGeneratorStatusQuery$variables = {
  taskId: number;
};
export type sideGeneratorStatusQuery$data = {
  readonly sideGeneratorTaskStatus: {
    readonly errorMessage: string | null;
    readonly resultUrl: string | null;
    readonly state: AIStudioTaskState;
  } | null;
};
export type sideGeneratorStatusQuery = {
  response: sideGeneratorStatusQuery$data;
  variables: sideGeneratorStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "taskId",
        "variableName": "taskId"
      }
    ],
    "concreteType": "SideGeneratorTaskStatus",
    "kind": "LinkedField",
    "name": "sideGeneratorTaskStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resultUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sideGeneratorStatusQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "sideGeneratorStatusQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "06ccdba169007f7a92ee16974716f7c2",
    "id": null,
    "metadata": {},
    "name": "sideGeneratorStatusQuery",
    "operationKind": "query",
    "text": "query sideGeneratorStatusQuery(\n  $taskId: Long!\n) {\n  sideGeneratorTaskStatus(taskId: $taskId) {\n    state\n    resultUrl\n    errorMessage\n  }\n}\n"
  }
};
})();

(node as any).hash = "e5972152269ca4534ec4827027f4ef25";

export default node;
